import { Menu, type MenuSelectGroupProps } from "@overmap-ai/blocks"
import type { ProcedureInitiative, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { ProcedureTypeIcon } from "../Icons/ProcedureTypeIcon"
import { ProcedureInitiativeIndexLabel } from "../IndexLabels/ProcedureInitiativeIndexLabel"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type ProcedureInitiativeSelectGroupProps = MenuSelectGroupProps<Stored<ProcedureInitiative>> & {
	procedureInitiatives: Stored<ProcedureInitiative>[]
}

export const ProcedureInitiativeSelectGroup = memo<ProcedureInitiativeSelectGroupProps>((props) => {
	const { ref, procedureInitiatives, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<ProcedureInitiative>> ref={ref} {...rest}>
			{procedureInitiatives.map((procedureInitiative) => {
				return (
					<SelectItemTemplate<Stored<ProcedureInitiative>>
						key={procedureInitiative.uuid}
						value={procedureInitiative}
					>
						<ProcedureTypeIcon procedureTypeId={procedureInitiative.procedure_type} inline />
						<ProcedureInitiativeIndexLabel
							procedureInitiativeId={procedureInitiative.uuid}
							className="truncate"
						/>
					</SelectItemTemplate>
				)
			})}
		</Menu.SelectGroup>
	)
})

ProcedureInitiativeSelectGroup.displayName = "ProcedureInitiativeSelectGroup"
